import { AlbumItem } from '@/types/album-api'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AlbumState {
    hotAlbums: AlbumItem[]
    topAlbums: AlbumItem[]
    topTotal: number
}

const initialState: AlbumState = {
    hotAlbums: [],
    topAlbums: [],
    topTotal: 0,
}

const albumSlice = createSlice({
    name: 'album',
    initialState,
    reducers: {
        changeTopAlbums(state, action: PayloadAction<AlbumItem[]>) {
            state.topAlbums = action.payload
        },
        changeHotAlbums(state, action: PayloadAction<AlbumItem[]>) {
            state.hotAlbums = action.payload
        },
        changeTopTotal(state, action: PayloadAction<number>) {
            state.topTotal = action.payload
        },
    },
})

export const { changeTopAlbums, changeHotAlbums, changeTopTotal } = albumSlice.actions

export default albumSlice.reducer
